module.exports = __webpack_public_path__ + "7b100d61aadaa5a9dfc56807270ab214.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reaction-feedback/sad.png
// module id = 3400
// module chunks = 0